enum CandidateStatus {
    None = 'none',
    Assessment = 'assessment',
    NotSuitable = 'not_suitable',
    Rejected = 'rejected',
    Suitable = 'suitable',
}

export default CandidateStatus
